

import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const TicketsAssignmentsService = {

    getConfig: (account_id) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/get-settings/${account_id}`);
    },

    update: (data) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/update-setting`, data);
    }
}